import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AccountService } from '../services/account';
import { AuthSourceEmail } from '../const/AuthConst';
import { HistoryEventService } from '../services/history.event.service';
import { delay, from, interval, map, of, take } from 'rxjs';
import { NgxMaskDirective } from 'ngx-mask';
import { formatDate, formatNumber } from '@angular/common';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
  NgxMaskDirective
];

@Component({
  selector: 'app-emailAuth',
  standalone: true,
  imports: [MODULES],
  templateUrl: './email-auth.component.html',
  styleUrl: './email-auth.component.css',
})
export class EmailAuthComponent {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private historyEventService: HistoryEventService,
  ) {
    this.onTextBoxChange();
    this.SendBtnText = "Отправить код";
  }

  private changeDetectorRef = inject(ChangeDetectorRef);

  /**
   * True - отображается экран ввода email, false - экран ввода кода
   */
  public IsShowCodeSend: boolean = true;
  public SendButtonStyle: string = "";
  public EmailText: string = "";
  public CodeText: string = "";
  public ErrorMessage: string = "";
  public ErrorCodeMessage: string = "";
  public CheckCodeBlockStyle: string = "";
  public TimerMessage: string = "";
  public TimerCounter: number = 0;
  public SendButtonEnabled = true;
  public SendButtonVisible = true;
  public SendBtnText = "";
  private counterValue: number = 60;

  public onTextBoxChange() {
    this.SendButtonStyle = this.EmailText.length == 0 ? "disabled" : "";
  }

  public onCodeChange() {
    this.CheckCodeBlockStyle = "";
    this.ErrorCodeMessage = "";
    if (this.CodeText.length == 6) {
      this.checkCode();
    }
  }

  public onClickSendBtn() {
    if (this.SendButtonEnabled) {
      this.SendButtonEnabled = false;
      this.accountService.accountSendCode(this.EmailText).subscribe({
        next: (data) => {
          this.IsShowCodeSend = false;
          this.ErrorMessage = "";
          this.SendButtonStyle = "";
          this.SendButtonEnabled = true;
          this.showTimer();
          this.changeDetectorRef.markForCheck();
        },
        error: (err) => {
          if (err.status != 200) {
            this.ErrorMessage = "Ошибка отправки кода подверждения";
            this.SendButtonEnabled = true;
            this.changeDetectorRef.markForCheck();
          }
        },
      })
    }
  }

  public checkCode() {
    this.accountService.accountCheckCode(this.EmailText, this.CodeText).subscribe({
      next: (data) => {
        if (data.accountId != "-1") {
          this.accountService.checkProfileAndSetInfo(data, AuthSourceEmail);
        }
        else {
          this.router.navigate(['noaccount']);
        }
      },
      error: (err) => {
        if (err.status == 400) {
          this.ErrorCodeMessage = "Неверный код. Попробуйте еще раз";
          this.CheckCodeBlockStyle = "show-error";
          if (this.TimerCounter == 0) {
            this.showTimer();
          }
        }
      },
    })
  }

  public onClickCloseBtn() {
    this.router.navigate([""]);
  }

  public onClickBackBtn() {
    this.router.navigate([""]);
  }

  /**
   * Отображение таймера обратного отчета для доступа к кнопке "Отправить код повторно"
   */
  private showTimer() {
    this.SendButtonVisible = false;
    this.ErrorMessage = "";
    this.changeDetectorRef.markForCheck();

    const delayTimer = interval(1000);
    this.TimerCounter = this.counterValue;

    delayTimer
      .pipe(take(this.counterValue), map(() => {
        this.TimerCounter--;
        this.TimerMessage = "Получить новый код через 00:" + formatNumber(this.TimerCounter, "en-EN", "2.0");
        this.changeDetectorRef.markForCheck();
        return this.TimerCounter
      }
      ))
      .subscribe(
        {
          next: x => {
          },
          complete: () => {
            this.SendButtonVisible = true;
            this.SendButtonStyle = "";
            this.CodeText = "";
            this.CheckCodeBlockStyle = "";
            this.SendBtnText = "Отправить код повторно";
            this.TimerCounter = 0;
            this.changeDetectorRef.markForCheck();
          }
        });
  }
}
